import React, { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdTongeJunWonSaYu = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: '',
    });

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newParams = {
            ...searchParams,
            [name]: type === 'checkbox' ? (checked ? "1" : "") : value
        };
        setSearchParams(newParams);
    };

    const dataHead = [['의료기관명', '종별', '지역', '기관수', '전체건수', '전원율', '전원사유별', '전원사유별', '전원사유별', '전원사유별', '전원사유별', '전원사유별', '전원사유별', '전원사유별'],
    ['의료기관명', '종별', '지역', '기관수', '전체건수', '전원율', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧']];
    const dataColumn = ['TNAME', 'EMCTYPE', 'EMCLOCA', 'EMCCOUNT', 'RECCOUNT', 'TT1', 'TT2', 'TT3', 'TT4', 'TT5', 'TT6', 'TT7', 'TT8', 'TT9'];
    const apiCall = '/ptmiapi/hosptrans/bdtongejunwonsayulist.do';
    const apiCntCall = '';
    const searchParamsAdditional = {};
    const excelFileName = "전원사유별 전원율";
    const excelHead = ['의료기관명', '종별', '지역', '기관수', '전체건수', '전원율', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'];
    const mergeConfig = [{ key: 'TNAME', row: null }, { key: 'EMCTYPE', row: 2, nullable: 'true' }, { key: 'EMCLOCA', row: 2, nullable: 'true' }, { key: 'EMCCOUNT', row: 2 }]

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });
    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={false}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                            <th>기&emsp;간</th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                ~
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <div>
                                    <span>
                                        <input type="checkbox" id="searchCheck1" name="searchCheck1" checked={searchParams.searchCheck1 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck1">진료외 방문 (챠트복사, 경유를 위한 접수) 제외</label>
                                    </span>
                                    <span>
                                        <input type="checkbox" id="searchCheck2" name="searchCheck2" checked={searchParams.searchCheck2 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck2">실시간 데이터 기준</label>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
        </Main>
    )
}

export default BdTongeJunWonSaYu;